import { render } from "./ProfileBranchInputs.vue?vue&type=template&id=6c85a1ed&scoped=true"
import script from "./ProfileBranchInputs.vue?vue&type=script&lang=js"
export * from "./ProfileBranchInputs.vue?vue&type=script&lang=js"

import "./ProfileBranchInputs.vue?vue&type=style&index=0&id=6c85a1ed&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c85a1ed"]])

export default __exports__